import { supabase } from '../config/supabaseConfig.ts';

/**
 * Requiere tabla en Supabase:
 *
 * create table admin_agents (
 *   id            uuid primary key default gen_random_uuid(),
 *   auth_user_id  uuid references auth.users(id) on delete cascade,
 *   full_name     text not null,
 *   email         text not null,
 *   role          text default 'admin',
 *   is_active     boolean default true,
 *   created_at    timestamptz default now(),
 *   updated_at    timestamptz default now()
 * );
 * alter table admin_agents enable row level security;
 * create policy "admins_full" on admin_agents for all using (true);
 *
 * Requiere Edge Functions:
 *   - admin-create-user  → { full_name, email, password, role }
 *   - admin-update-user  → { auth_user_id, full_name?, email?, password? }
 */

export const adminAccountsService = {

  getAll: async () => {
    const { data, error } = await supabase
      .from('admin_agents')
      // admin_agents.password no es legible por authenticated: columnas explícitas
      .select('id, full_name, email, phone, created_at')
      .order('created_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  create: async ({ full_name, email, password, role = 'admin' }) => {
    const { data, error } = await supabase.functions.invoke('admin-create-user', {
      body: { full_name, email, password, role },
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return data;
  },

  update: async (id, { full_name, email, auth_user_id }) => {
    // Actualiza perfil en tabla
    const { error: tableError } = await supabase
      .from('admin_agents')
      .update({ full_name, email, updated_at: new Date().toISOString() })
      .eq('id', id);
    if (tableError) throw tableError;

    // Actualiza metadata en auth via Edge Function
    const { data, error: fnError } = await supabase.functions.invoke('admin-update-user', {
      body: { auth_user_id, full_name, email },
    });
    if (fnError) throw fnError;
    if (data?.error) throw new Error(data.error);
  },

  resetPassword: async (auth_user_id, password) => {
    const { data, error } = await supabase.functions.invoke('admin-update-user', {
      body: { auth_user_id, password },
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
  },

  toggleActive: async (id, is_active) => {
    const { error } = await supabase
      .from('admin_agents')
      .update({ is_active, updated_at: new Date().toISOString() })
      .eq('id', id);
    if (error) throw error;
  },

  delete: async (id, auth_user_id) => {
    // Borra auth user via Edge Function (cascadea a admin_agents por FK)
    const { data, error } = await supabase.functions.invoke('admin-update-user', {
      body: { auth_user_id, delete: true },
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
  },
};
